import { z } from "zod";

const AiLog = z.object({
  id: z.number(),
  createdAt: z.coerce.date(),
  type: z.string(),
  label: z.string(),
  requestId: z.string(),
  project: z.object({ id: z.number(), name: z.string() }).nullable(),
  chapter: z
    .object({
      id: z.number(),
      projectTemplateChapterSlug: z.string(),
      project: z.object({
        id: z.number(),
        name: z.string()
      })
    })
    .nullable(),
  executionTimeMs: z.number().nullable(),
  user: z
    .object({
      id: z.number(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string()
    })
    .nullable(),
  errors: z.string().nullable(),
  cacheHit: z.boolean().nullable(),
  costs: z
    .object({
      tokens: z
        .object({
          inputTokens: z.number(),
          outputTokens: z.number(),
          totalTokens: z.number(),
          cacheReadTokens: z.number().optional()
        })
        .optional(),
      meta: z
        .object({
          model: z.string(),
          source: z.enum(["exact", "approximate"])
        })
        .optional(),
      cost: z
        .object({
          total: z.number(),
          currency: z.string(),
          pricingModel: z.string(),
          source: z.enum(["exact", "approximate"]).optional()
        })
        .nullish()
    })
    .nullable()
});

export const AiLogSchema = AiLog.extend({
  requestParams: z.any().nullable(),
  response: z.any().nullable()
});

export const AiLogsSchema = z.array(AiLog);

export const AiLogsByRequestIdSchema = z.array(
  z.object({
    requestId: z.string(),
    rows: AiLogsSchema
  })
);

export type AiLog = z.infer<typeof AiLogSchema>;
export type AiLogsByRequestId = z.infer<typeof AiLogsByRequestIdSchema>;
